import { inject, Injectable } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { filter, switchMap, take } from 'rxjs/operators';
import {
  AddIcdCodeWebRequest,
  IcdCodeHeaderRowItemSearchResult,
  IcdCodeItem,
  IcdCodeMeta,
  IcdCodeType,
  MhsConfigurationApiClient,
  SetIcdCodeMetaEntryWebRequest,
  VerifyIcdCodeWebRequest,
} from '../../../core/api/mhsConfigurationApiClient';
import { AuthStore } from '../../../core/authentication/authStore';
import { UsertStore } from '../../../core/context/userStore';

@Injectable({
  providedIn: 'root',
})
export class CodesService {
  configurationApiClient = inject(MhsConfigurationApiClient);
  authStore = inject(AuthStore);
  userStore = inject(UsertStore);

  search(
    pageIndex: number,
    pageSize: number,
    type: IcdCodeType,
    phrase: string,
    isVerified?: string,
    orderBy?: string,
    isOrderByAsc?: boolean,
  ): Observable<IcdCodeHeaderRowItemSearchResult> {
    if (this.authStore.accessToken() === '') {
      return EMPTY;
    }
    return this.userStore.currentTenant$.pipe(
      filter((tenant) => tenant !== null),
      take(1),
      switchMap((tenant) => {
        const tenantName = tenant?.tenantName;
        return this.configurationApiClient.icdCode_Search(
          type,
          phrase,
          isVerified,
          pageIndex,
          pageSize,
          orderBy,
          isOrderByAsc,
        );
      }),
    );
  }

  create(request: AddIcdCodeWebRequest): Observable<IcdCodeItem> {
    return this.configurationApiClient.icdCode_Add(request);
  }

  get(type: IcdCodeType, code: string): Observable<IcdCodeItem> {
    return this.configurationApiClient.icdCode_GetByCode(type, code);
  }

  getCodeById(type: IcdCodeType, codeId: number): Observable<IcdCodeItem> {
    return this.configurationApiClient.icdCode_GetById(type, codeId);
  }

  // edit(request: AddIcdCodeWebRequest): Observable<IcdCodeItem> {
  //   return this.configurationApiClient.icd(request);
  // }

  verify(request: VerifyIcdCodeWebRequest): Observable<void> {
    return this.configurationApiClient.icdCode_Verify(request);
  }

  setMeta(
    type: IcdCodeType,
    id: number,
    metaKey: string,
    entries: IcdCodeMeta[],
  ): Observable<void> {
    return this.configurationApiClient.icdCode_SetMetaEntry(
      new SetIcdCodeMetaEntryWebRequest({ type, id, metaKey, entries }),
    );
  }
}
